import { useQueryClient } from '@tanstack/react-query';
import { smartCollectionQueryKeys } from '../queries/smartCollection.queryKeys.js';
import { useOptimisticallyUpdateQueriesWithPredicate, useOptimisticallyUpdateQueryDetailData, upsertItemInArrayById } from '@fabric-app/queries/utilities';
import equal from 'fast-deep-equal';

const useUpdateCachedSmartCollection = () => {
  const queryClient = useQueryClient();
  const optimisticallyUpdateQueries = useOptimisticallyUpdateQueriesWithPredicate();
  const optimisticallyUpdateItemQuery = useOptimisticallyUpdateQueryDetailData();
  const updateCachedSmartCollection = (itemData) => {
    queryClient.cancelQueries({
      predicate: (q) => q.queryKey[0] === smartCollectionQueryKeys.all[0],
      type: "active"
    });
    const optimisticUpdateAllQueries = optimisticallyUpdateQueries((q) => {
      return equal(q.queryKey, smartCollectionQueryKeys.list());
    }, (data) => upsertItemInArrayById(data ?? [], itemData, {
      createIfNotFound: false
    }));
    const optimisticUpdateItemQuery = optimisticallyUpdateItemQuery(smartCollectionQueryKeys.item(itemData.id), itemData);
    return {
      optimisticUpdateAllQueries,
      resetCacheToPreOptimisticState: () => {
        optimisticUpdateAllQueries.resetQueriesData();
        optimisticUpdateItemQuery.resetDetailData();
      },
      invalidateQueries: () => {
        optimisticUpdateAllQueries.invalidateQueries();
        optimisticUpdateItemQuery.invalidateQueries();
      }
    };
  };
  return updateCachedSmartCollection;
};

export { useUpdateCachedSmartCollection };
//# sourceMappingURL=smartCollectionMutationHelpers.js.map
